export default function Footer() {
  return (
    <footer style={{ borderTop: '1px solid var(--border)', padding: '28px 0' }}>
      <div className="wrap footer-inner">
        <span style={{ fontFamily: 'Jost', fontWeight: 300, fontSize: 16, letterSpacing: '0.28em' }}>
          <span style={{ color: 'var(--accent)' }}>Z</span>OLYM
        </span>
        <span className="zmono" style={{ fontSize: 11, color: 'var(--faint)' }}>
          © 2026 Zolym · built for teams that ship
        </span>
      </div>
    </footer>
  )
}
